var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lightFormat_1 = __importDefault(require("date-fns/lightFormat"));
const isValid_1 = __importDefault(require("date-fns/isValid"));
function trySerializeDate(val, options = {}) {
    if (!(val instanceof Date)) {
        return val;
    }
    try {
        const { includeTime } = options;
        if (!(0, isValid_1.default)(val)) {
            return null;
        }
        return includeTime ? val.toISOString() : (0, lightFormat_1.default)(val, 'yyyy-MM-dd');
    }
    catch (_a) { }
    return val;
}
exports.default = trySerializeDate;
//# sourceMappingURL=trySerializeDate.js.map